import axiosCommonInstance from "../utils/axiosCommon";

export const GetGCPSignedUploadUrl = async (values) => {
    return await axiosCommonInstance().post("admin/common/get-signed-upload-url", values);
}